/* NDC · Fase 3 (home): flechas del carrusel en desktop + evento GA4 de CTAs. Vanilla, defer, idempotente. */
(function () {
  'use strict';
  if (window.__ndcHomeInit) return;
  window.__ndcHomeInit = true;

  function initCarousel(wrap) {
    if (wrap.dataset.ndcReady) return;
    wrap.dataset.ndcReady = '1';
    var track = wrap.querySelector('[data-ndc-carousel]');
    var prev = wrap.querySelector('[data-ndc-prev]');
    var next = wrap.querySelector('[data-ndc-next]');
    if (!track || !prev || !next) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var card = track.querySelector('.ndc-card');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
      return card ? (card.getBoundingClientRect().width + gap) * 2 : track.clientWidth * 0.8;
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      wrap.classList.toggle('has-overflow', overflow);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ndc-carousel-wrap]').forEach(initCarousel);
  }

  // GA4 (dataLayer) para los CTAs de home: data-ndc-cta="club_home" etc.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ndc-cta]');
    if (!a) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'home_cta_click', cta: a.getAttribute('data-ndc-cta'), href: a.getAttribute('href') || '' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Editor de temas: re-inicializar cuando se (re)carga una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
